/**
 * Angular library starter.
 * Build a library compatible with Angular, AoT compilation & Tree shaking.
 * Written by Roberto Simonetti.
 * MIT license.
 * https://github.com/robisim74/jsql-angular
 */

/**
 * Entry point for all public APIs of the package.
 */
export {JsqlService,JsqlModule} from './src/jsql-angular';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
